export const STORE_FAQS = 'StoreFaqs';
export const STORE_COMERCES = 'StoreCommerces';

export const SENDING_REQUEST = 'FaqsSendingRequest';
export const REQUEST_ERROR = 'FaqsRequestError';


export const COMMERCES_REQUEST_DATA = 'CommercesRequestData';

export const FAQS_REQUEST_DATA = 'FaqsRequestDaata';
export const FAQS_SERVICIOS_CP = 'FaqsServiciosCP';
export const FAQS_PROBLEMAS = 'FaqsProblemas';
export const FAQS_INSTRUCCIONES = 'FaqsInstrucciones';
export const FAQS_SEGURIDAD = 'FaqsSeguridad';

